import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative me-1 mr-8" }
const _hoisted_5 = { style: {"width":"300px"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Status", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  value: "READ",
  key: "Terbaca"
}, "Terbaca", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  value: "unread",
  key: "Belum DiBaca"
}, "Belum Terbaca", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_10 = {
  key: 0,
  style: {"width":"300px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Status", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  value: "payment_status=paid",
  key: "bayar"
}, "Terbayar", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", {
  value: "payment_status=unpaid",
  key: "belum bayar"
}, " Belum Terbayar ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  value: "other_filter=manual",
  key: "manual"
}, "Manual", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", {
  value: "other_filter=confirmation_finance",
  key: "confirmation_finance"
}, " Konfirmasi Finance ", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_17 = { class: "align-items-center position-relative" }
const _hoisted_18 = { class: "card-body py-3" }
const _hoisted_19 = { class: "table-responsive" }
const _hoisted_20 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama Notifikasi"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Email"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Aksi")
], -1)
const _hoisted_22 = { class: "fw-bolder text-muted" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1)
const _hoisted_24 = { class: "min-w-125px; text-center" }
const _hoisted_25 = { class: "min-w-125px; text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, null, -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "text-left" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { class: "text-left" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "row mt-5 mb-5" }
const _hoisted_48 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_49 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_50 = ["label", "value"]
const _hoisted_51 = { class: "p-3" }
const _hoisted_52 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_53 = { class: "pagination" }
const _hoisted_54 = {
  class: "modal fade",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  id: "kt_modal_notif",
  ref: "notifModalRef"
}
const _hoisted_55 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_56 = { class: "modal-content rounded" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "modal-title mb-6" }, "Detail Notifikasi")
], -1)
const _hoisted_58 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-5" }
const _hoisted_59 = { class: "card-body p-9" }
const _hoisted_60 = { class: "row mb-7" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Tanggal", -1)
const _hoisted_62 = { class: "col-lg-9" }
const _hoisted_63 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_64 = { class: "row mb-7" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Nama", -1)
const _hoisted_66 = { class: "col-lg-9" }
const _hoisted_67 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_68 = { class: "row mb-7" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Email", -1)
const _hoisted_70 = { class: "col-lg-9" }
const _hoisted_71 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_72 = { class: "row mb-7" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Type", -1)
const _hoisted_74 = { class: "col-lg-9" }
const _hoisted_75 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_76 = { class: "row mb-7" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Status", -1)
const _hoisted_78 = { class: "col-lg-9" }
const _hoisted_79 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_80 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_81 = {
  key: 2,
  class: "badge badge-danger"
}
const _hoisted_82 = { class: "row mb-7" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-3 fw-bold" }, "Pesan", -1)
const _hoisted_84 = { class: "col-lg-9" }
const _hoisted_85 = { style: {"border-style":"groove","border-width":"1px","padding":"10px"} }
const _hoisted_86 = ["innerHTML"]
const _hoisted_87 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.schoolId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.schoolId) = $event)),
              placeholder: "Pilih Sekolah",
              mode: "single",
              "create-option": false,
              options: _ctx.listSekolah,
              searchable: true,
              label: "name",
              "track-by": "name",
              "value-prop": "_id",
              "max-height": 350,
              max: 5,
              style: {"width":"600px"},
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pilihSekolah($event)))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Field, {
              as: "select",
              class: "form-select form-select-lg",
              modelValue: _ctx.status,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status) = $event)),
              placeholder: "Pilih Status",
              mode: "single",
              "create-option": false,
              options: _ctx.listStatus,
              searchable: true,
              "value-prop": "_id",
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pilihStatus($event, _ctx.tableData)))
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            }, 8, ["modelValue", "options"])
          ]),
          _hoisted_9,
          (_ctx.roleuser == 'ADMIN_FINANCE')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_Field, {
                  as: "select",
                  class: "form-select form-select-lg",
                  modelValue: _ctx.statuss,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.statuss) = $event)),
                  placeholder: "Pilih Status",
                  mode: "single",
                  "create-option": false,
                  options: _ctx.listStatus,
                  searchable: true,
                  "value-prop": "_id",
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pilihStatuspembayaran($event)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14,
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              "data-bs-dismiss": "modal",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clickReset($event)))
            }, " Reset ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("table", _hoisted_20, [
            _createElementVNode("thead", null, [
              _hoisted_21,
              _createElementVNode("tr", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("th", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Cari Nama Notifikasi",
                    class: "form-control text-center",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.title) = $event)),
                    onKeyup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changePageSize(_ctx.paging.size)))
                  }, null, 544), [
                    [_vModelText, _ctx.title]
                  ])
                ]),
                _createElementVNode("th", _hoisted_25, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Cari Email",
                    class: "form-control text-center",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.email) = $event)),
                    onKeyup: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePageSize(_ctx.paging.size)))
                  }, null, 544), [
                    [_vModelText, _ctx.email]
                  ])
                ]),
                _hoisted_26
              ])
            ]),
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (item.status == 'WAIT' || item.status == 'SENT')
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                            _createElementVNode("td", _hoisted_29, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.dateTime2(item.createTime)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_30, [
                              _createElementVNode("strong", null, _toDisplayString(item.title), 1)
                            ]),
                            _createElementVNode("td", _hoisted_31, [
                              _createElementVNode("strong", null, _toDisplayString(item.email), 1)
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("a", {
                                class: "symbol symbol-35px me-2",
                                "data-bs-toggle": "tooltip",
                                title: "Detail",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (_ctx.readnotif(index, item))
                              }, _hoisted_35, 8, _hoisted_33)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                            _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.dateTime2(item.createTime)), 1),
                            _createElementVNode("td", _hoisted_38, _toDisplayString(item.title), 1),
                            _createElementVNode("td", _hoisted_39, _toDisplayString(item.email), 1),
                            _createElementVNode("td", _hoisted_40, [
                              _createElementVNode("a", {
                                class: "symbol symbol-35px me-2",
                                "data-bs-toggle": "tooltip",
                                title: "Detail",
                                style: {"cursor":"pointer"},
                                onClick: ($event: any) => (_ctx.readnotif(index, item))
                              }, _hoisted_43, 8, _hoisted_41)
                            ])
                          ]))
                    ], 64))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_44, _hoisted_46))
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changePageSize(_ctx.paging.size)))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_50))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_51, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("ul", _hoisted_53, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("span", _hoisted_63, " : " + _toDisplayString(_ctx.dateTime2(_ctx.detail.createTime)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("span", _hoisted_67, " : " + _toDisplayString(_ctx.detail.title), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("span", _hoisted_71, " : " + _toDisplayString(_ctx.detail.email), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("span", _hoisted_75, _toDisplayString(":" + " " + _ctx.detail.type), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _hoisted_77,
                  _createElementVNode("div", _hoisted_78, [
                    (_ctx.detail.status === 'WAIT')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_79, " Belum Terbaca "))
                      : _createCommentVNode("", true),
                    (_ctx.detail.status === 'READ')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_80, " Terbaca "))
                      : _createCommentVNode("", true),
                    (_ctx.detail.status === 'SENT')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_81, " Belum Terbaca "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _hoisted_83,
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("span", {
                        style: {"width":"auto","white-space":"pre-wrap"},
                        class: "fw-bolder fs-6 text-dark",
                        innerHTML: _ctx.detail.message_asli
                      }, null, 8, _hoisted_86)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setNumberNotif(_ctx.detail._id))),
                class: "btn btn-danger",
                "data-bs-dismiss": "modal"
              }, " Kembali "),
              (_ctx.isShowButtonKonfirmasiLegal == true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.konfirmasiLegal(_ctx.detail))),
                    class: "btn btn-primary",
                    "data-bs-dismiss": "modal"
                  }, " Konfirmasi Legalitas "))
                : _createCommentVNode("", true),
              (_ctx.isShowButtonKonfirmasiFinance == true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.konfirmasiPembayaran(_ctx.detail))),
                    class: "btn btn-primary",
                    "data-bs-dismiss": "modal"
                  }, " Konfirmasi Pembayaran Manual "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 512)
    ], 2)
  ], 64))
}